(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-centered-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Initialize the predictive search functionality
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      
      if (!this.input || !this.predictiveSearchResults) return;
      
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
    
    onChange() {
      const searchTerm = this.input.value.trim();
      
      if (!searchTerm.length) {
        this.close();
        return;
      }
      
      this.getSearchResults(searchTerm);
    }
    
    getSearchResults(searchTerm) {
      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          console.error(error);
        });
    }
    
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
    
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
    
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
});
  } catch(e) { console.error(e); }
})();

})();
